import React from "react";
import { Row, Col } from "reactstrap";
import moment from "moment";

import AppointmentListItemForm from "./AppointmentListItemForm";

const AppointmentListItems = (props) => {
  const getBorderColor = (status, deleted) => {
    //console.log(status, deleted);
    return {
      margin: "7px 0px",
      borderRight: deleted
        ? "#d9534f solid 2px"
        : status === 0
        ? "#292b2c solid 2px"
        : status === 1
        ? "#5bc0de solid 2px"
        : status === 2
        ? "#0275d8 solid 2px"
        : "#5cb85c solid 2px",
      verticalAlign: "top",
    };
  };
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h5>
            {props.date}
            {moment().isAfter(moment(props.date), "day")
              ? " - This date has passed, no more changes can be made."
              : ""}
          </h5>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div>
            {props.dateTimes.map((dt) => (
              <Row key={dt.appointmentId}>
                <Col
                  xs={3}
                  style={{
                    ...getBorderColor(dt.appointmentStatus, dt.deleted),
                  }}
                >
                  <b>
                    {moment(dt.timeSlotStart).format("LT")} -{" "}
                    {moment(dt.timeSlotEnd).format("LT")}
                  </b>
                </Col>
                <Col xs={9} style={{ padding: "10px 25px" }}>
                  <AppointmentListItemForm
                    appointmentId={dt.appointmentId}
                    user={dt.userId}
                    userQuestionnaireId={dt.userQuestionnaireId}
                    refreshMonth={props.refreshMonth}
                    timeSlotStart={dt.timeSlotStart}
                  />
                </Col>
              </Row>
            ))}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AppointmentListItems;
